import { render, staticRenderFns } from "./cadastral-district.vue?vue&type=template&id=10e78f70&scoped=true&lang=html&"
import script from "./cadastral-district.vue?vue&type=script&lang=js&"
export * from "./cadastral-district.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e78f70",
  null
  
)

export default component.exports